export default "__VITE_ASSET__Cz99YEnd__"